import { ButtonVariant } from '@billy/design-system'

import { InvoiceLogErrorKey } from '@features/invoicesLegacy/types/invoiceLogErrorKey'

export type ActionType =
  | 'voidInvoice'
  | 'resendEInvoice'
  | 'openSendModal'
  | 'openErrorDetailsModal'
  | 'cancelSendingEInvoice'

interface Action {
  action: ActionType
  tLabel: string
  buttonVariant?: ButtonVariant
}

export const errorKeyToAction: Partial<Record<InvoiceLogErrorKey, Action[]>> = {
  /* eslint-disable @typescript-eslint/naming-convention */
  attachments_unprocessable: [
    {
      action: 'voidInvoice',
      tLabel: 'einvoce.status.action.void',
    },
  ],
  request_error: [
    {
      action: 'openErrorDetailsModal',
      tLabel: 'einvoce.status.action.error_details',
      buttonVariant: 'outlined',
    },
  ],
  request_too_large: [
    {
      action: 'voidInvoice',
      tLabel: 'einvoce.status.action.void',
    },
  ],
  schema_invalid: [
    {
      action: 'voidInvoice',
      tLabel: 'einvoce.status.action.void',
    },
    {
      action: 'openErrorDetailsModal',
      tLabel: 'einvoce.status.action.error_details',
      buttonVariant: 'outlined',
    },
  ],
  schema_invalid_bank_digits: [
    {
      action: 'voidInvoice',
      tLabel: 'einvoce.status.action.void',
    },
    {
      action: 'openErrorDetailsModal',
      tLabel: 'einvoce.status.action.error_details',
      buttonVariant: 'outlined',
    },
  ],
  schema_invalid_zero_quantity: [
    {
      action: 'voidInvoice',
      tLabel: 'einvoce.status.action.void',
    },
    {
      action: 'openErrorDetailsModal',
      tLabel: 'einvoce.status.action.error_details',
      buttonVariant: 'outlined',
    },
  ],
  timeout: [
    {
      action: 'resendEInvoice',
      tLabel: 'einvoce.status.action.resend',
    },
    {
      action: 'voidInvoice',
      tLabel: 'einvoce.status.action.void',
      buttonVariant: 'outlined',
    },
  ],
  recipient_not_found: [
    {
      action: 'voidInvoice',
      tLabel: 'einvoce.status.action.void',
    },
  ],
  recipient_not_recognized: [
    {
      action: 'resendEInvoice',
      tLabel: 'einvoce.status.action.resend',
    },
    {
      action: 'openErrorDetailsModal',
      tLabel: 'einvoce.status.action.error_details',
      buttonVariant: 'outlined',
    },
  ],
  rejected: [
    {
      action: 'voidInvoice',
      tLabel: 'einvoce.status.action.void',
    },
  ],
  sender_cvr_mismatch: [
    {
      action: 'voidInvoice',
      tLabel: 'einvoce.status.action.void',
    },
  ],
  /* eslint-enable @typescript-eslint/naming-convention */
}
